import { render, staticRenderFns } from "./returnData.vue?vue&type=template&id=12ad40b6&scoped=true"
import script from "./returnData.vue?vue&type=script&lang=js"
export * from "./returnData.vue?vue&type=script&lang=js"
import style0 from "./returnData.vue?vue&type=style&index=0&id=12ad40b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ad40b6",
  null
  
)

export default component.exports